import forEach from 'lodash/forEach'
import isObject from 'lodash/isObject'
import get from 'lodash/get'
import forOwn from 'lodash/forOwn'
import omit from 'lodash/omit'
import set from 'lodash/set'

import { requiredCheck } from '../required-check/index'
import { unFlattenObject } from '../unflatten-object'
import { flattenObject } from '../flatten-object'

export function pickAndOmitKeys(
  obj: Record<any, any>,
  fieldName: string | string[]
): { picked: Record<string, any>; omitted: Record<string, any> } {
  requiredCheck(obj, 'obj')

  //we need to flatten then  unflatten to so that dot notation can be properly handled
  const unFlattenedObj = unFlattenObject(flattenObject(obj, { array: true }))

  //we need to make sure the fieldName is an array
  let fieldNames: string[] = []
  if (!Array.isArray(fieldName)) {
    fieldNames = [fieldName]
  } else {
    fieldNames = fieldName
  }

  //this is container for the found keys
  const foundKeys = []

  //a recursive function to recurse all fields of the object and look for the keys
  const recurse = (recuseObj: any, parentKey?: string) => {
    forOwn(recuseObj, (value, key) => {
      const path = parentKey ? `${parentKey}.${key}` : key
      if (fieldNames.includes(key)) {
        //add to the set the found key
        foundKeys.push(path)
      } else if (isObject(value)) {
        return recurse(value, path)
      }
    })
  }

  //run it once here
  recurse(unFlattenedObj)

  //passed the original object to the omitted as initial value
  let omitted = { ...unFlattenedObj }

  //the initial value for picked is empty
  const picked = {}

  //loop thru all keys to pick and omit they keys from the object
  forEach(foundKeys, (fieldKey) => {
    //as dot notation object, build a picked object
    //picked[fieldKey] = get(omitted, fieldKey)
    set(picked, fieldKey, get(omitted, fieldKey))

    //removed one by one from the clonedObj the keys
    omitted = omit(omitted, fieldKey)
  })

  //because the picked is still in dot notation object, we need to unflatten it
  //picked = unFlattenObject(picked)
  //picked = picked

  return { omitted, picked }
}
